$(document).ready(function($){

  // JS for accordion
  $('.cs-accordion-content').first().show();
  $('.cs-accordion-heading').first().addClass('sft-faq-active');

  $('.cs-accordion-heading').click(function() {
    $('.cs-accordion-content').slideUp();
    $('.cs-accordion-heading').removeClass('sft-faq-active');

    if (!$(this).next('.cs-accordion-content').is(':visible')) {
      $(this).next('.cs-accordion-content').slideDown();
      $(this).addClass('sft-faq-active');
    }
  });

  $('.cs-testimonial-slider').slick({
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
    dots: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          centerMode: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  // Scroll to reviews section when star rating is clicked
  // JDHT-SITE-2026-06-15-002: Fixed broken fallback section ID that caused dead clicks
  // on all product pages (Bluetooth HA confirmed in Clarity). Previous fallback
  // '#shopify-section-1772726396aff5fb23' did not exist on any live template, so
  // e.preventDefault() consumed the tap but nothing scrolled. Three-tier fallback:
  //   1. Judge.me widget in DOM (works after lazy load)
  //   2. Walk up from any jdgm-prefixed element to its shopify-section wrapper
  //   3. Known section IDs: standard-product review widget, then carousel
  $('.rating-wrapper').css('cursor', 'pointer').on('click', function(e){
    e.preventDefault();
    // Tier 1: Try Judge.me widget selectors (active reviews on this template)
    var $target = $('.jdgm-widget, .jdgm-carousel-wrapper, .jdgm-rev-widg').first();
    // Tier 2: Walk up from any jdgm-prefixed element to its shopify-section wrapper
    if (!$target.length) {
      var $jdgmEl = $('[class*="jdgm-"]').first();
      if ($jdgmEl.length) {
        $target = $jdgmEl.closest('[id^="shopify-section-"]');
      }
    }
    // Tier 3: Known section IDs per template
    // standard-product: 17727063630bd77ddc (review widget), 17727062119648d111 (carousel)
    // jd-931: 177401610170558e6b (combined carousel + review widget)
    if (!$target.length) {
      $target = $(
        '#shopify-section-17727063630bd77ddc,' +
        '#shopify-section-17727062119648d111,' +
        '#shopify-section-177401610170558e6b'
      ).first();
    }
    if ($target.length) {
      $('html, body').animate(
        { scrollTop: $target.offset().top - 80 }, 800
      );
    }
  });

  // Fix: require active variant selection before ATC enables.
  //
  // Problem: on size-variant products (e.g. Domes), the page pre-selects the first
  // variant (Extra Small) and the ATC button is immediately live. Customers click
  // without consciously choosing their size — confirmed as dead/wrong-size clicks
  // in Microsoft Clarity.
  //
  // v9 uses three parallel unlock strategies to handle all Dawn DOM patterns:
  //   A. document change event — native radio/label pattern (isTrusted=true on change)
  //   B. variant-selects click — Dawn's swatch/pill pattern, where user clicks a
  //      styled <label> and Dawn programmatically sets the radio (isTrusted=false
  //      on the resulting change, so strategy A misses it). A direct click on the
  //      variant-selects element is always isTrusted.
  //   C. After initComplete (100ms): drop the isTrusted requirement on change events,
  //      since Dawn's init is done and only the user can trigger changes at that point.
  //
  // To add more products: append their Shopify handle to requireSelectionHandles.
  var requireSelectionHandles = [
    'replacement-cic-hearing-amplifier-domes',
    'replacement-ear-domes-for-clarity-pro-cic-hearing-amplifiers-pack-of-10'
  ];

  var shopifyMeta = window.ShopifyAnalytics &&
                    window.ShopifyAnalytics.meta &&
                    window.ShopifyAnalytics.meta.product;

  if (shopifyMeta && requireSelectionHandles.indexOf(shopifyMeta.handle) !== -1) {
    var reqSubmitBtn = document.querySelector('[id^="ProductSubmitButton-"]');
    var reqForm = document.querySelector('product-form form, form[action="/cart/add"]');

    if (reqSubmitBtn && reqForm) {
      var userHasSelected = false;
      var initComplete = false;

      function applySelectionGuard() {
        reqSubmitBtn.setAttribute('aria-disabled', 'true');
        reqSubmitBtn.style.pointerEvents = 'none';
        reqSubmitBtn.style.opacity = '0.6';
        if (!document.getElementById('jdht-selection-hint')) {
          var selectionHint = document.createElement('p');
          selectionHint.id = 'jdht-selection-hint';
          selectionHint.style.cssText = 'color:#0F5BB2;font-size:0.85rem;margin:0.4rem 0 0;font-weight:500;text-align:center;';
          selectionHint.textContent = 'Please select a size to continue';
          reqSubmitBtn.parentNode.insertBefore(selectionHint, reqSubmitBtn.nextSibling);
        }
      }

      function unlockATC() {
        if (userHasSelected) return;
        userHasSelected = true;
        guardObserver.disconnect();
        reqSubmitBtn.removeAttribute('aria-disabled');
        reqSubmitBtn.style.pointerEvents = '';
        reqSubmitBtn.style.opacity = '';
        var hint = document.getElementById('jdht-selection-hint');
        if (hint) hint.remove();
      }

      applySelectionGuard();

      // Clear Dawn's pre-selection after its init sequence completes (~100ms).
      // After this timeout: any change event on a radio must be user-triggered.
      setTimeout(function() {
        if (!userHasSelected) {
          document.querySelectorAll('input[type="radio"]').forEach(function(r) {
            // Only clear option inputs (leave quantity, gift-card, etc. alone)
            if (r.form && r.form.action && r.form.action.indexOf('/cart/add') !== -1) {
              r.checked = false;
            }
          });
          initComplete = true;
        }
      }, 100);

      // Capture-phase submit blocker
      reqForm.addEventListener('submit', function(e) {
        if (!userHasSelected) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);

      // MutationObserver re-applies guard if Dawn removes aria-disabled during init
      var guardObserver = new MutationObserver(function() {
        if (!userHasSelected) applySelectionGuard();
      });
      guardObserver.observe(reqSubmitBtn, { attributes: true, attributeFilter: ['aria-disabled'] });

      // Strategy A: document-level change — catches native radio/label pattern.
      // Before initComplete: require e.isTrusted (blocks Dawn's programmatic dispatches).
      // After initComplete: allow any change (Dawn's init is done, only user can trigger).
      document.addEventListener('change', function(e) {
        if (userHasSelected) return;
        if (!e.target.matches('input[type="radio"], select')) return;
        if (!initComplete && !e.isTrusted) return;
        unlockATC();
      });

      // Strategy B: click on variant-selects element.
      // In Dawn's swatch/pill pattern the user clicks a <label> or styled button;
      // Dawn then programmatically sets the radio — the resulting change event has
      // isTrusted=false and Strategy A misses it. Clicking inside variant-selects
      // is always a conscious size interaction, so we unlock on any trusted click there.
      var variantSelects = document.querySelector('variant-selects');
      if (variantSelects) {
        variantSelects.addEventListener('click', function(e) {
          if (userHasSelected || !e.isTrusted) return;
          // 10ms delay lets Dawn update the radio state before we unlock
          setTimeout(unlockATC, 10);
        });
      }
    }
  }

  // Fix: dual ATC double-fire on rapid mobile taps.
  //
  // Root cause: the sticky ATC button's IIFE handler guards with `realSubmit.disabled`,
  // but product-form.js never sets `.disabled` — it sets `aria-disabled` during the
  // fetch. On a fast double-tap, `.disabled` is still false so the guard passes twice
  // and two cart-add requests fire.
  //
  // Fix: attach a capture-phase listener to the PARENT BAR element (not the button).
  document.querySelectorAll('.sticky-atc').forEach(function(bar) {
    var stickyBtn = bar.querySelector('.sticky-atc__btn');
    if (!stickyBtn) return;

    var sectionId = bar.id.replace('sticky-atc-', '');
    var submitting = false;

    bar.addEventListener('click', function(e) {
      if (!stickyBtn.contains(e.target)) return;

      var realSubmit = document.getElementById('ProductSubmitButton-' + sectionId);
      var ariaDisabled = realSubmit && realSubmit.getAttribute('aria-disabled') === 'true';

      if (submitting || ariaDisabled) {
        e.stopImmediatePropagation();
        e.preventDefault();
        return;
      }

      submitting = true;
      setTimeout(function() { submitting = false; }, 2000);
    }, true);
  });

});
